import { gsap, TimelineMax } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger, TimelineMax);

export default {
  init() {
    let container = document.querySelector("#scroll-container");
    console.log(container);

   /*  let height;
    function setHeight() {
      height = container.clientHeight;
      document.body.style.height = height + "px";
    }
    ScrollTrigger.addEventListener("refreshInit", setHeight); */

    gsap.to('.navbar',{
      scrollTrigger: {
        trigger: document.body,
        start: "50px", 
        endTrigger:"html", end:"bottom top",
        toggleActions: 'play reverse none reverse',
        toggleClass: {targets: '.navbar', className: "navbar--not-top"}
      }
    });

    // smooth scrolling container
    /* gsap.to(container, {
      y: () => -(height - document.documentElement.clientHeight),
      ease: "none",
      scrollTrigger: {
        trigger: document.body,
        start: "top top",
        end: "bottom bottom",
        scrub: 1,
        invalidateOnRefresh: true,
      },
    }); */
  },
};
